import React from 'react'
import { Box, Flex } from 'rebass'
import styled from 'styled-components'
import { Parallax } from 'react-scroll-parallax'
import { StaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

import media from '../components/Media'
import Tiltable from '../components/Tiltable'

const LeftImageWrap = styled(Box)`
  display: none;
  position: absolute;
  left: 15%;
  top: 10%;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.5);

  @media (min-width: ${props => props.theme.breakpoints[0]}) {
    display: inline-flex;
  }
`

const RightImageWrap = styled(Box)`
  display: none;
  position: absolute;
  right: 15%;
  top: 10%;
  z-index: 20;

  @media (min-width: ${props => props.theme.breakpoints[0]}) {
    display: inline-flex;
  }
`

const HeroWrap = styled(Flex)`
  ${media.desktop`
    min-height: 700px;
  `}
`

const query = graphql`
  query {
    black: file(relativePath: { eq: "title-black.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1440) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    cream: file(relativePath: { eq: "title-cream.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1440) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    left: file(relativePath: { eq: "hero-left.jpg" }) {
      childImageSharp {
        fixed(height: 215, width: 215) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    right: file(relativePath: { eq: "hero-right.jpeg" }) {
      childImageSharp {
        fixed(height: 185, width: 287) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`

const TopHero = props => {
  return (
    <StaticQuery
      query={query}
      render={data => (
        <HeroWrap flexDirection={['column', 'row']}>
          <Flex
            flexDirection="column"
            justifyContent="flex-end"
            css={{ position: 'relative' }}
            bg="black"
            flex={1}
          >
            <Box pt={[56]} pb={[56]}>
              <Img fluid={data.black.childImageSharp.fluid} />
            </Box>
            <LeftImageWrap>
              <Parallax y={[-20, 30]}>
                <Tiltable>
                  <Img fixed={data.left.childImageSharp.fixed} />
                </Tiltable>
              </Parallax>
            </LeftImageWrap>
          </Flex>
          <Flex
            flexDirection="column"
            justifyContent="flex-end"
            bg="yellow"
            flex={1}
            css={{ position: 'relative' }}
          >
            <Box pt={[56]} pb={[56]}>
              <Img fluid={data.cream.childImageSharp.fluid} />
            </Box>
            <RightImageWrap>
              <Parallax y={[-50, 50]}>
                <Tiltable>
                  <Img
                    style={{
                      boxShadow: '0 2px 15px 0 rgba(0, 0, 0, 0.5)',
                      transform: 'rotate(15deg)',
                    }}
                    fixed={data.right.childImageSharp.fixed}
                  />
                </Tiltable>
              </Parallax>
            </RightImageWrap>
          </Flex>
        </HeroWrap>
      )}
    />
  )
}
export default TopHero
